import React from "react";
import clsx from "clsx";
import { makeStyles } from "@mui/styles";
import { useSelector } from "react-redux";
import { palette } from "../../../theme/palette";
import { WarningIcon } from "../../Icons";
import { View } from "../../Base";
import OverrideConflictsPopover from "./OverrideConflictsPopover";
import { overrideAreasSelector } from "../../../reducers/matrixProfile/selectors";
import { getOverridesConflictsAreas } from "../../../utils/overrides";

const useStyles = makeStyles(() => ({
  container: {
    display: "flex",
    alignItems: "center",
  },
  infoIcon: {
    margin: "0 4px 0 15px",
    fill: palette.typography.white.high,
    cursor: "pointer",
  },
  warningIcon: {
    width: "16px",
    height: "16px",
  },
  fillOrange: {
    fill: palette.orange,
  },
}));

const OverrideConflictsComponent = () => {
  const styles = useStyles();
  const overrideAreas = useSelector(overrideAreasSelector);
  const [warningAnchorEl, setWarningAnchorEl] = React.useState(null);
  const overridesConflictsAreas = getOverridesConflictsAreas({ overrideAreas });

  if (!overridesConflictsAreas.length) return null;

  return (
    <View className={styles.container}>
      <WarningIcon
        className={clsx(
          styles.infoIcon,
          styles.warningIcon,
          warningAnchorEl ? styles.fillOrange : null
        )}
        onClick={(event) => setWarningAnchorEl(event.currentTarget)}
      />
      {overridesConflictsAreas.length}
      <OverrideConflictsPopover
        overridesConflictsAreas={overridesConflictsAreas}
        open={!!warningAnchorEl}
        onClose={() => setWarningAnchorEl(null)}
        anchorEl={warningAnchorEl}
      />
    </View>
  );
};

export default OverrideConflictsComponent;
